export const API_URL = "https://api.tylt.money";
export const API_KEY_EURO = "442012ee491d4a402f46c99770efd695c39dde9d0ac7e3ed";
export const API_SECRET_EURO =
  "3f74180fa3a2cf6f30303e1904c26b8cefb4c8ec9427c92fbaca3576153f3896";
export const API_KEY_CAD = "01d8c4277cc17bc803bd565cad5c9dda6a1a3d06c4c4666f";
export const API_SECRET_CAD =
  "ff8527e505d81623bc22ac4e7c4bc2a02779b3d4c555ef8938f3021982d6d76a";
export const WS_BASE_URL = "wss://ws.tylt.money";
export const REDIRECT_URL =
  typeof window !== "undefined" ? window.location.origin : "";
export const CALLBACK_URL =
  typeof window !== "undefined" ? window.location.origin : "";
